import { IDLE } from "../../global/statusLabels"
import { RESET_ANAGRAFE_STATE, RICERCA_COMUNI_SUCCESS, RICERCA_ISCRIZIONE_SUCCESS } from "./actionsType"

export const initialState = {
    ricercaIscrizione: { value: undefined, status: IDLE },
    ricercaComuni: { value: undefined, status: IDLE },
}

export const anagrafeReducer = (state = initialState, action) => {
    switch (action.type) {
        case RICERCA_ISCRIZIONE_SUCCESS:
            return {
                ...state,
                ricercaIscrizione: action.payload
            }
        case RICERCA_COMUNI_SUCCESS:
            return {
                ...state,
                ricercaComuni: action.payload
            }
        case RESET_ANAGRAFE_STATE:
            return initialState;
        default:
            return state;
    }
}